// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"36999cec","463":"e632464e","765":"3c9ac67b","768":"533ba96e"}[chunkId] + ".css";
};